






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { TOP_MENU } from '@/constants/top-menu.constant';

@Component({
  name: 'AppHeaderMenu',
})
export default class AppHeaderMenu extends Vue {
  @Prop({ default: () => [] }) items!: typeof TOP_MENU;
  @Prop({ default: false }) subTree!: boolean;
  @Prop({ default: false }) isTopMenu!: boolean;
  @Prop({ default: false }) isMobileMenu!: boolean;

  closeMenu(event: MouseEvent) {
    const subMenu = (event.target as Element).closest('.sub-menu');
    if (!this.isMobileMenu) {
      if (subMenu) {
        subMenu.classList.add('closed');
        setTimeout(() => {
          subMenu.classList.remove('closed');
        }, 300);
      }
    }
  }

  onMenuTopItemClick(menuItem: typeof TOP_MENU[number]) {
    if (!menuItem.children && menuItem.route) {
      this.$router.push(menuItem.route);
    }
  }
}
